import { useContext } from 'react';
import { StepItemContext } from '../context';

export const useStepItem = () => {
  const context = useContext(StepItemContext);
  if (!context) {
    throw new Error('useStepItem must be used within a StepperItem');
  }
  return context;
};
